export default "__VITE_ASSET__DCuI_cPz__";